export enum SurveyEvent {
  Start = 'Survey - Start',
  Complete = 'Survey - Complete',
  SaveResponse = 'Survey - Save Response',
  EarlyExitAlert = 'Survey - Early Exit Alert',
  EarlyExitConfirmed = 'Survey - Early Exit Confirmed',
  EarlyExitCanceled = 'Survey - Early Exit Canceled',
  SurveyFallbackUsed = 'Survey - Fallback Used'
}

export enum InsuranceSurveyEvents {
  EligibleScreen = 'Insurance Survey - Web - Eligible Screen',
  IneligibleScreen = 'Insurance Survey - Web - Ineligible Screen'
}

export enum Scheduling {
  InitialAppointmentTypeViewed = 'Scheduling - Web - Initial Appointment Type Viewed',
  AppointmentBooked = 'Scheduling - Web - Appointment Booked',
  AppointmentReserved = 'Scheduling - Web - Appointment Reserved',
  SlotIsAlreadyTaken = 'Scheduling - Web - Slot Is Already Taken'
}

export enum VideoCalls {
  HealthGoal = 'User - Video Call Goal',
  WeightLossQuoteViewed = 'User - Weight Loss Quote Viewed',
  InsuranceResponse = 'Standalone - Insurance Response',
  InsuranceSupportedViewed = 'Standalone - Insurance Supported Viewed',
  InsuranceNotAcceptedViewed = 'Standalone - Insurance Not Accepted Viewed',
  SubmitEmail = 'User - Submit Email Address',
  SubmitState = 'User - Submit State',
  SubmitAgenda = 'Standalone - Submit Agenda',
  HeardAboutUs = 'Standalone - Heard about us'
}

export enum Glp {
  Goal = 'User - Glp Goal',
  WeightLossQuote = 'User - Glp Weight Loss Quote',
  TriedLoseWeight = 'User - Tried Lose Weight',
  State = 'User - State',
  DateOfBirth = 'User - Date Of Birth',
  MedicalHistory = 'User - Medical History',
  Bmi = 'User - BMI',
  Conditions = 'User - Conditions',
  WeightLossAmount = 'User - Weight Lost Amount',
  Shipping = 'User - Shipping',
  Checkout = 'User - Checkout',
  PaymentSuccessful = 'User - Payment Successful',
  Descent = 'User - Descent'
}

export enum OwnSensor {
  HealthGoal = 'User - Own Sensor Goal',
  WeightLossQuoteViewed = 'User - Weight Loss Quote Viewed',
  MobileOperatingSystem = 'User - Mobile Operating System',
  SelectedSensor = 'User - Selected Sensor',
  EligibilityCheck = 'User - Eligibility Options Selected'
}

export enum UserEvents {
  ViewSignUp = 'User - View Sign Up',
  SignUp = 'User - Sign Up',
  Identify = 'User - Identify',
  SubmitAddress = 'User - Submit Address',
  CreateSubscription = 'User - Create Subscription',
  CreditCardAdded = 'User - Credit Card Added'
}

export enum UserEventsSource {
  VideoCallFlow = 'Video Call Flow',
  DPPFlow = 'DPP Flow',
  MedicalFlow = 'Medical Flow',
  Checkout = 'Checkout'
}
